import React, {useEffect, useRef, useState} from "react";
import CreateIconYellow from "../../../../assets/icons/add-circle-yellow.svg";
import CreateIcon from "../../../../assets/icons/add-circle.svg";
import "./style.scss";
import {Tooltip} from "@mui/material";
import axios from "axios";
import CopyToClipboard from "react-copy-to-clipboard";
import {useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {ToastContainer, toast} from "react-toastify";
import copyIcon from "../../../../assets/icons/copy-big.svg";
import {baseUrl} from "../../../../utils/apis";
import ReactTable from "../../../ReactTable/ReactTable";
import {formatUSD} from "../../../../utils/helpers/string";

function OverviewTable() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalContent(null);
    setIsModalOpen(false);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      marginTop: "4px",
      height: 48,
      borderRadius: 8,
      border: "none",
      boxShadow: "none",
      paddingRight: "20px",
      fontFamily: "DM Sans , sans-serif",
      fontSize: "14px",
      fontWeight: 700,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
  };
  const [isChallengeDropdown, setChallengeDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.classList.contains("column_header")) {
        setChallengeDropdown(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  const idToken = useSelector((state) => state.auth.idToken);
  const [codeList, setCodeList] = useState([]);

  useEffect(() => {
    let config = {
      headers: {
        Authorization: "Bearer " + idToken,
      },

      params: {
        ...(selectedBrand?.brand === "crypto_edge" ? {crypto: true} : {}),
      },
    };
    axios
      .get(`${baseUrl}/affiliates/list/`, config)
      .then((res) => {
        setCodeList(res.data.data);
      })
      .catch((err) => {});
  }, [idToken]);

  const data = React.useMemo(() => codeList, [codeList]);
  const navigate = useNavigate();
  const handleCheckStatus = (id) => {
    navigate(`/affiliate-list/${id}`);
  };
  const truncateString = (inputString, maxLength) => {
    const formattedString = inputString.toString();
    if (formattedString.length > maxLength) {
      return inputString.toString().substring(0, maxLength) + "...";
    }
    return inputString;
  };

  const handleCopyToClipboard = (text) => {
    toast("Text copied to clipboard !", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Code",
        accessor: "code",
        Cell: ({row}) => (
          <div
            // onClick={() => handleCheckStatus(row.original.id)}
            className="column_one_wrapper_test"
            style={{paddingLeft: "20px"}}
          >
            <div className="side_lines">
              <div>{row.original.code}</div>
            </div>
          </div>
        ),
      },
      {
        Header: (
          <>
            {/* <div className="column_header"> */}
            Commission %{/* <img src={vectorIcon} alt="arrow-down" />{" "} */}
            {/* </div> */}
          </>
        ),
        accessor: "percentage",
        Cell: ({row}) => (
          <div
            // onClick={() => handleCheckStatus(row.original.id)}
            style={{width: "120px"}}
          >
            {row.original.percentage}%
          </div>
        ),

        //   sortType: "login_id",
      },

      {Header: "Signups", accessor: "reffered_list_count", Cell: ({row}) => <div style={{width: "120px"}}>{row.original.reffered_list_count}</div>},
      {
        Header: "Url",
        accessor: "url",
        Cell: ({row}) => {
          return (
            <div
              className="url"
              style={{display: "flex", width: "82%", alignItems: "center"}}
            >
              {" "}
              <Tooltip
                title={<span style={{fontSize: "14px"}}>{row.original.url}</span>}
                placement="top"
                arrow="bottom"
                style={{display: "flex", alignItems: "center"}}
              >
                <b
                  className="url-content"
                  style={{paddingRight: "10px"}}
                >
                  {row.original.url}
                </b>
                <CopyToClipboard
                  onCopy={handleCopyToClipboard}
                  text={row.original?.url}
                >
                  {/* <button> */}
                  <p
                    className="table_copy_button"
                    style={{
                      marginRight: "20px",
                      // backgroundColor: "#35d269",
                      cursor: "pointer",
                    }}
                    // onClick={() => handleCopyToClipboard(row.original?.payment_id)}
                  >
                    {/* <ContentCopyIcon sx={{fontSize: "20px", backgroundColor: "#35d269", color: "black"}} /> */}
                    <img
                      style={{height: "18px"}}
                      src={copyIcon}
                      alt=""
                    />
                  </p>
                  {/* </button> */}
                </CopyToClipboard>
              </Tooltip>
            </div>
          );
        },
        className: "url_address",
      },
      {
        Header: (
          <>
            {/* <div className="column_header"> */}
            Discount %{/* <img src={vectorIcon} alt="arrow-down" />{" "} */}
            {/* </div> */}
          </>
        ),
        accessor: "discount",
        Cell: ({row}) => (
          <div
            // onClick={() => handleCheckStatus(row.original.id)}
            style={{width: "120px"}}
          >
            {row.original.discount}%
          </div>
        ),

        //   sortType: "login_id",
      },
      {
        Header: <>Total Commission</>,
        accessor: "commission_amount",
        Cell: ({row}) => <div style={{width: "120px"}}>{formatUSD(row.original.commission_amount)}</div>,

        //   sortType: "login_id",
      },
      {Header: "Used by", accessor: "consumed_by_count"},
    ],
    [],
  );
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="overview_table">
      <div className=" table_wrapper">
        <div className="table_header">
          {/* <div className="search">
            <div className="search_bar">
              <input
                type="text"
                className="search_input"
                placeholder="Search..."
              />
              <img
                className="search_icon"
                src={Search}
                alt="search icon"
              />
            </div>
            <img
              className=""
              src={CalenderIcon}
              alt="calender icon"
            />
          </div> */}
          <h2>Affiliate Codes</h2>
          <Link to="/affiliate/get-a-link">
            {" "}
            <div className="create_wrapper">
              <img
                className="create_icon"
                src={selectedBrand?.brand === "equity_edge" ? CreateIcon : selectedBrand?.brand === "crypto_edge" ? CreateIconYellow : CreateIcon}
                alt="create"
              />
              <p>Create Affiliate Code</p>
            </div>{" "}
          </Link>
        </div>
        <div className="table_scroll_wrapper">
          {/* <Table openModal={openModal} /> */}
          <ReactTable
            columns={columns}
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
        <ModalPopup
          isModalOpen={isModalOpen}
          modalContent={modalContent}
          openModal={openModal}
          closeModal={closeModal}
        />
      </div>{" "}
      <ToastContainer />
    </div>
  );
}

export default OverviewTable;

const ModalPopup = ({isModalOpen, modalContent, closeModal}) => {
  if (!isModalOpen) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <button
          className="close"
          onClick={closeModal}
        >
          &times;
        </button>
        <h2>Referred List</h2>
        <p>{modalContent}</p>
      </div>
    </div>
  );
};
